import { SparklesIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { revealStyle, useStagedReveal } from './stagedReveal';

export interface WhatsNewWelcomeProps {
    headline: string;
    subtitle: string;
}

const REVEAL_STEPS = 3;
const REVEAL_FIRST_DELAY_MS = 100;
const REVEAL_STEP_MS = 350;
const HEADLINE_RISE_PX = 24;

export const WhatsNewWelcome: React.FC<WhatsNewWelcomeProps> = ({ headline, subtitle }) => {
    const stage = useStagedReveal(REVEAL_STEPS, REVEAL_FIRST_DELAY_MS, REVEAL_STEP_MS);

    return (
        <div className="flex flex-col items-center justify-center w-full h-full">
            <div
                className="flex items-center justify-center w-14 h-14 rounded-2xl bg-yellow-50 border border-yellow-200 transition-all duration-700 ease-out"
                style={revealStyle(stage >= 1)}
            >
                <SparklesIcon className="w-7 h-7 text-yellow-500" />
            </div>
            <h2
                className="text-4xl font-bold text-gray-900 tracking-tight mt-6 text-center transition-all duration-700 ease-out"
                style={revealStyle(stage >= 2, HEADLINE_RISE_PX)}
            >
                {headline}
            </h2>
            <p
                className="text-base text-gray-400 text-center mt-3 leading-relaxed transition-all duration-700 ease-out"
                style={revealStyle(stage >= 3)}
            >
                {subtitle}
            </p>
        </div>
    );
};
